<template>
  <div class="container">
    <div v-if="imageSrc" class="illustration-wrapper">
      <img v-if="imageSrc" :src="imageSrc" alt="illustration" class="illustration" />
    </div>
    <div class="text-wrapper">
      <h1 v-if="title">
        {{ title }}
      </h1>
      <p v-if="subtitle">
        {{ subtitle }}
      </p>
    </div>
    <button
      v-if="confirmActionText"
      @click="confirmAction"
      class="white--text mr-2 v-btn theme--light primary"
    >
      {{ confirmActionText }}
    </button>
  </div>
</template>

<script>
export default {
  props: {
    illustration: {
      type: String,
      validator(value) {
        return ['404', '500', '403-Version2', 'searchPeople'].includes(value)
      },
      default: '404'
    },
    title: {
      type: String,
      default: ''
    },
    subtitle: {
      type: String,
      default: ''
    },
    confirmActionText: {
      type: String,
      default: ''
    },
    confirmAction: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {
      imageSrc: null
    }
  },
  watch: {
    illustration: {
      immediate: true,
      handler(newName) {
        this.loadImage(newName)
      }
    }
  },
  methods: {
    loadImage(illustration) {
      try {
        this.imageSrc = require(`@/assets/images/illustrations/${illustration}.svg`)
      } catch (error) {
        console.error(`Image not found: ${illustration}`, error)
      }
    }
  }
}
</script>

<style scoped>
.container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  gap: 24px;
  max-width: 646px;
}
.illustration {
  max-width: 100%;
  height: auto;
}
.text-wrapper {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
h1 {
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 100%;
  margin: 0;
  color: var(--neutral-high-dark);
}
p {
  color: var(--neutral-high-lightest);
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  margin: 0;
}
</style>
